import { i18n } from "../../../core/services/i18n-service";
import { ChartComponent } from "../charts/chart.component";
// @ts-ignore
import styleCSS from "./chart-tabs.style.scss?inline"

export class ChartTabsComponent extends HTMLElement {
    private _shadowRoot: ShadowRoot;
    private _chartContainer: HTMLDivElement;
    private _chartIds: string[];
    private _tabsContainer: HTMLDivElement;

    constructor() {
        super();
        this._shadowRoot = this.attachShadow({ mode: "open" });
    }

    connectedCallback() {
        this.init();

        const style = document.createElement('style');
        style.textContent = styleCSS;
        this._shadowRoot.appendChild(style);
    }

    init() {
        this._chartIds = this.getAttribute('ids')?.split(',') || [];
        this.setGUI()
    }

    setGUI() {
        this._tabsContainer = document.createElement('div') as HTMLDivElement
        this._tabsContainer.classList.add('tabs-wrapper')
        this.createTabs(this._tabsContainer)
        this._shadowRoot.appendChild(this._tabsContainer)
        this._chartContainer = document.createElement('div') as HTMLDivElement
        this._chartContainer.classList.add('chart-container')
        this._shadowRoot.appendChild(this._chartContainer)

        this.createChart(this._chartIds[0], this._chartContainer)
        const firstTab = this._tabsContainer.firstChild as HTMLButtonElement
        firstTab.classList.add('active')
    }

    private createTabs(container:HTMLDivElement) {
        this._chartIds.forEach((t: string) => {
            const tab = document.createElement('button')
            tab.setAttribute('chart-type', t)
            tab.innerHTML = `
            <span>${i18n.t(t)}</span>
            `
            tab.classList.add('tab-button')
            tab.addEventListener('click', () => this.onClickTab(tab))
            container.appendChild(tab)
        })
    }

    private onClickTab(tab: HTMLButtonElement) {
        if (tab.classList.contains('active')) {
            return;
        }
        
        this._chartContainer.innerHTML = ''
        this._tabsContainer.querySelectorAll('button').forEach((t: HTMLButtonElement) => {
            t.classList.remove('active')
        })
        tab.classList.add('active')
        
        this.createChart(tab.getAttribute('chart-type') || '', this._chartContainer)
    }

    private createChart(id: string, container: HTMLDivElement) {
        const chart = new ChartComponent();
        chart.setAttribute('chart-type', id);
        chart.setAttribute('series-type', 'Stacked Area');
        container.appendChild(chart);
    }
}
